import { ResizableEvent } from '../directives/resizable/resizable.directive';
import { KeyboardUtil } from '../utils/keyboard.util';

export class PopupFactory {
  preMaximizeRootWidth: number;
  preMaximizeRootHeight: number;
  preMaximizeBodyHeight: number;
  preMaximizePageX: number;
  preMaximizePageY: number;
  maximized: boolean;
  executePostDisplayActions: boolean;
  contentzIndex: number;
  zIndex: number = 99;
  dragEventTarget: MouseEvent | TouchEvent;

  private _visible: boolean;
  keyboardUtil: KeyboardUtil
  constructor() {
    this.keyboardUtil = KeyboardUtil.getInstance();
    this._visible = false;
  }

  set visible(value: boolean) {
    this._visible = value;

    if (this._visible) {
      this.keyboardUtil.popupsOpenedCount++;
    } else {
      this.keyboardUtil.popupsOpenedCount--;
    }
  }

  get visible(): boolean {
    return this._visible;
  }

  center(rootElement): void {
    let elementWidth = rootElement.offsetWidth;
    let elementHeight = rootElement.offsetHeight;

    if (elementWidth === 0 &&
      elementHeight === 0) {
      rootElement.style.visibility = 'hidden';
      rootElement.style.display = 'block';
      elementWidth = rootElement.offsetWidth;
      elementHeight = rootElement.offsetHeight;
      rootElement.style.display = 'none';
      rootElement.style.visibility = 'visible';
    }
    const x = Math.max((window.innerWidth - elementWidth) / 2, 0);
    const y = Math.max((window.innerHeight - elementHeight) / 2, 0);
    rootElement.style.left = x + 'px';
    rootElement.style.top = y + 'px';
  }

  disablePopupBackground(modals): void {
    if (!this.zIndex) {
      this.zIndex = this.getMaxModalIndex(modals);
      this.zIndex = (this.zIndex || 1000) + 1;
    }

    this.contentzIndex = this.zIndex + 1;
  }

  getMaxModalIndex(modals) {
    let zIndex = 0;

    [].forEach.call(modals, function (modal) {
      const indexCurrent = parseInt(modal.style.zIndex, 10);
      if (indexCurrent > zIndex) {
        zIndex = indexCurrent;
      }
    });
    return zIndex;
  }

  calcBodyHeight(modalHeader, modalFooter, modalRoot, modalBody) {
    const diffHeight = modalHeader.offsetHeight + modalFooter.offsetHeight;
    const contentHeight = modalRoot.offsetHeight - diffHeight;
    modalBody.style.height = contentHeight + 'px';
    modalBody.style.maxHeight = 'none';
  }

  restorePopup(modalRoot): void {
    if (this.executePostDisplayActions) {
      this.center(modalRoot);
      this.executePostDisplayActions = false;
    }
  }

  onResize(event: ResizableEvent, modalHeader, modalFooter, modalRoot, modalBody) {
    if (event.direction === 'vertical') {
      this.calcBodyHeight(modalHeader, modalFooter, modalRoot, modalBody);
    }
  }

  toggleMaximize(event, modalHeader, modalFooter, modalRoot, modalBody) {
    if (this.maximized) {
      this.revertMaximize(modalRoot, modalBody);
    } else {
      this.maximize(modalRoot, modalFooter, modalHeader, modalBody);
    }
    event.preventDefault();
  }

  maximize(modalRoot, modalFooter, modalHeader, modalBody) {
    this.preMaximizePageX = parseFloat(modalRoot.style.top);
    this.preMaximizePageY = parseFloat(modalRoot.style.left);
    this.preMaximizeRootWidth = modalRoot.offsetWidth;
    this.preMaximizeRootHeight = modalRoot.offsetHeight;
    this.preMaximizeBodyHeight = modalBody.offsetHeight;

    modalRoot.style.top = '0px';
    modalRoot.style.left = '0px';
    modalRoot.style.width = '100vw';
    modalRoot.style.height = '100vh';
    const diffHeight = modalHeader.offsetHeight + modalFooter.offsetHeight;
    modalBody.style.height = 'calc(100vh - ' + diffHeight + 'px)';
    modalBody.style.maxHeight = 'none';
    this.maximized = true;
  }

  revertMaximize(modalRoot, modalBody) {
    modalRoot.style.top = this.preMaximizePageX + 'px';
    modalRoot.style.left = this.preMaximizePageY + 'px';
    modalRoot.style.width = this.preMaximizeRootWidth + 'px';
    modalRoot.style.height = this.preMaximizeRootHeight + 'px';
    modalBody.style.height = this.preMaximizeBodyHeight + 'px';

    this.maximized = false;
  }

  initDrag(event: MouseEvent | TouchEvent) {
    if (!this.maximized) {
      this.dragEventTarget = event;
    }
  }
}